import trans from 'common/tools/translations/trans';

export type ShowtimeGroupKey =
  | 'dubbed'
  | 'dubbed_st'
  | 'dubbed_st_sme'
  | 'local'
  | 'local_st'
  | 'local_st_sme'
  | 'multiple'
  | 'multiple_st'
  | 'multiple_st_sme'
  | 'original'
  | 'original_st'
  | 'original_st_sme';

const suffixes = {
  original: '',
  original_st: 'ST',
  original_st_sme: 'ST - SME',
  dubbed: '',
  dubbed_st: ' ST',
  dubbed_st_sme: ' ST - SME',
  local: '',
  local_st: ' ST',
  local_st_sme: ' ST - SME',
  multiple: '',
  multiple_st: ' ST',
  multiple_st_sme: ' ST - SME'
};

const dubbedTrans = trans('showtimes.format', {
  name: trans('showtimes.version.dubbed')
});
const localTrans = trans('showtimes.format', {
  name: trans('showtimes.version.local')
});
const multipleTrans = trans('showtimes.format', {
  name: trans('showtimes.version.translated')
});
const originalTrans = trans('showtimes.format', {
  name: trans('showtimes.version.original')
});

export const getVersionLabel = (key: ShowtimeGroupKey): string => {
  if (key.startsWith('dubbed')) {
    return dubbedTrans + suffixes[key];
  }
  if (key.startsWith('local')) {
    return localTrans + suffixes[key];
  }
  if (key.startsWith('multiple')) {
    return multipleTrans + suffixes[key];
  }
  if (key.startsWith('original')) {
    return originalTrans + suffixes[key];
  }
  return '';
};

export default getVersionLabel;
